import React from "react";

/**
 * CaptionBlock
 * ------------
 * Renders the post caption + hashtags INSIDE the device frame. Per spec, captions
 * are NOT chat text below the preview — they live where they'd appear on the real
 * platform surface.
 *
 * Props:
 *   - text:     caption text (string).
 *   - hashtags: optional array of strings (tags rendered without the "#" prefix).
 *   - brand:    optional { handle, display_name, avatar_url, verified, ... }.
 *   - className/style: optional pass-through.
 *
 * Platform-specific positioning (above-asset for FB/LI, overlay for Reels/Stories)
 * is Agent C's scope — this component just produces the caption line. Parents place it.
 */
export default function CaptionBlock({ text, hashtags = [], brand, className, style }) {
  if (!text && (!hashtags || hashtags.length === 0)) return null;

  const handle = brand?.handle || brand?.display_name || "your_brand";

  return (
    <div
      className={["vella-caption-block", className].filter(Boolean).join(" ")}
      style={{
        padding: "8px 14px 12px",
        fontSize: 13,
        lineHeight: 1.45,
        color: "#0F172A",
        ...(style || {}),
      }}
    >
      {text ? (
        <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>
          <span style={{ fontWeight: 700, marginRight: 6 }}>{handle}</span>
          {text}
        </p>
      ) : null}
      {hashtags && hashtags.length > 0 ? (
        <p
          style={{
            margin: "6px 0 0",
            color: "#1D4ED8",
            fontWeight: 500,
            whiteSpace: "pre-wrap",
          }}
        >
          {hashtags.map((t) => `#${String(t).replace(/^#/, "")}`).join(" ")}
        </p>
      ) : null}
    </div>
  );
}
